module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"edit-notify:title":"Редактирование","edit-notify:text":"Статус успешно изменен"}}')
  delete Component.options._Ctor
}
